class GetAdminConfiguration {
  constructor() {
    this.RegMethods = [];
    this.RegMethods[0] = {
      Id: 1,
      MemberType: 'Employee',
      RegType: 'ActivationCode',
    };
    this.RegMethods[1] = { Id: 2, MemberType: 'Employee', RegType: 'MemberID' };
    this.RegMethods[2] = { Id: 3, MemberType: 'Employee', RegType: 'UserInfo' };
    this.RegMethods[3] = {
      Id: 4,
      MemberType: 'Dependent',
      RegType: 'ActivationCode',
    };
    this.RegMethods[4] = {
      Id: 5,
      MemberType: 'Dependent',
      RegType: 'MemberID',
    };
    this.RegMethods[5] = {
      Id: 6,
      MemberType: 'Dependent',
      RegType: 'UserInfo',
    };

    this.getAdminConfigurationtResp = null;

    this.WaysOfReg = [];
    this.Oid = [];

    //"Employee",
    //"Dependent"
    this.MemberType = [];

    //"MemberID",
    //"ActivationCode",
    //"UserInfo"
    this.RegistrationBy = [];

    //Only UserInfo
    this.NumberOfItemsToMatch = [];

    //"Invisible",
    //"Visible",
    //"Required" - only of userInfo
    this.FirstName = [];
    this.LastName = [];
    this.DateOfBirth = [];
    this.Email = [];
    this.AddressLine1 = [];
    this.AddressLine2 = [];
    this.Status = [];
    this.City = [];
    this.State = [];
    this.PostalCode = [];
    this.Relationship = []; //Only for Dependent
    this.PhoneNumber = [];
    this.ClientID = [];
    this.ClientName = [];
    this.PlanID = [];
    this.SSN = [];
    this.CertificateNumber = [];
    this.AlternateID1 = [];
    this.AlternateID2 = [];
    this.MedicareID = [];

    //Insurance Client Settings
    this.insuranceClientOid = null;
    this.AllowMembersToRegister = 'NO';
    this.AllowDependentsToRegister = 'NO';
    this.DefaultMemberRole = 'NA';
    this.DefaultDependentRole = 'NA';
    this.DependentRegistrationAgeLimit = 0;
    this.TwoFARequired = 'NO';
    this.InvalidOTPAttemptRestriction = 'false';
    this.OTPLength = 0;
    this.OTPExpiresIn = 0;
    this.FirstTimeRegistration = 'TRUE';
    this.Login = 'TRUE';
    this.FrequencyForTwoFA = 0;
    this.AllowSetTrustedDevice = 'NO';
    this.FrequencyForTrustedDevice = 0;
    this.FrequencyTypeForTrustedDevice = 'Days';
    this.InvalidOTPAttempts = 0;

    //Reset Options
    this.resetOptionsLength = 0;
    this.resetOid = [];
    this.resetRecordType = [];
    this.resetMemberType = [];
    this.resetDisclaimer = [];
    this.resetAllowRecoveryUsingAltMail = [];
    this.resetFirstName = [];
    this.resetLastName = [];
    this.resetDateOfBirth = [];
    this.resetEmail = [];
    this.resetAddressLine1 = [];
    this.resetAddressLine2 = [];
    this.resetCity = [];
    this.resetState = [];
    this.resetPostalCode = [];
    this.resetRelationship = [];
    this.resetPhoneNumber = [];
    this.resetClientID = [];
    this.resetClientName = [];
    this.resetPlanID = [];
    this.resetSSN = [];
    this.resetCertificateNumber = [];
    this.resetAlternateID1 = [];
    this.resetAlternateID2 = [];
    this.resetMedicareID = [];
    this.resetAlternateEmail = [];
    this.resetMemberID = [];

    this.resetFirstNameOption = [];
    this.resetLastNameOption = [];
    this.resetDateOfBirthOption = [];
    this.resetRelationshipOption = [];
    this.resetPhoneNumberOption = [];
    this.resetSSNOption = [];
    this.resetAlternateID1Option = [];
    this.resetAlternateID2Option = [];
    this.resetPostalCodeOption = [];
    this.resetMedicareIDOption = [];
    this.resetAlternateEmailOption = [];
    this.resetMemberIDOption = [];

    //Password Rules
    this.pwdRulesOid = null;
    this.pwdRulesPasswordMinLength = 0;
    this.pwdRulesPasswordMaxLength = 0;
    this.pwdRulesNoOfUpperCaseReqd = 0;
    this.pwdRulesNoOfNumericsReqd = 0;
    this.pwdRulesNoOfSpecialCharactersReqd = 0;
    this.pwdRulesRestrictQWERTYLetters = 0;
    this.pwdRulesAllowSpacesInPassword = 'NO';
    this.pwdRulesNoOfLastPasswordsUsed = 0;
    this.pwdRulesAllowUnlockDisabledLogin = 'NO';
    this.pwdRulesInvalidAttemptRestriction = 'NO';
    this.pwdRulesNoOfInvalidPasswordRecoveries = 0;
    this.pwdRulesNoOfInvalidAttempts = 0;
  }

  getAdminConfigurationResp() {
    return this.getAdminConfigurationtResp;
  }

  setAdminConfigurationResp(AdminConfigurationtResp) {
    this.getAdminConfigurationtResp = AdminConfigurationtResp;
  }
  mapWaysOfReg(iIndex, response) {
    if (iIndex === 1) {
      return (
        response?.InsurerClientSettings?.MemberRegistrationRequiredMemberID ===
        'true'
      );
    } else if (iIndex === 2) {
      return (
        response.InsurerClientSettings
          .MemberRegistrationRequiredFindMyAccount === 'true'
      );
    } else if (iIndex === 4) {
      return (
        response.InsurerClientSettings.DependentRegistrationRequiredMemberID ===
        'true'
      );
    } else if (iIndex === 5) {
      return (
        response.InsurerClientSettings
          .DependentRegistrationRequiredFindMyAccount === 'true'
      );
    } else {
      return null;
    }
  }

  ParseAdminConfiguration() {
    let iIndex = 0,
      innerIdx = 0,
      regConfigLength = 0;
    this.initializeAdminConfig();
    if (
      typeof this.getAdminConfigurationtResp.Response.ConfigurableFields !=
      'undefined'
    ) {
      regConfigLength =
        this.getAdminConfigurationtResp.Response.ConfigurableFields?.length;

      for (iIndex = 0; iIndex < this.RegMethods?.length; iIndex++) {
        for (innerIdx = 0; innerIdx < regConfigLength; innerIdx++) {
          if (
            this.RegMethods[iIndex].MemberType ===
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].MemberType &&
            this.RegMethods[iIndex].RegType ===
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].RegistrationBy
          ) {
            this.WaysOfReg[iIndex] = this.mapWaysOfReg(
              iIndex,
              this.getAdminConfigurationtResp.Response,
            );
            this.Oid[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].OID;
            this.MemberType[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].MemberType;
            this.RegistrationBy[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].RegistrationBy;
            this.NumberOfItemsToMatch[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].NumberOfItemsToMatch;
            this.FirstName[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].FirstName;
            this.LastName[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].LastName;
            this.DateOfBirth[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].DateOfBirth;
            this.Email[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].Email;
            this.AddressLine1[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].AddressLine1;
            this.AddressLine2[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].AddressLine2;
            this.Status[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].Status;
            this.City[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].City;
            this.State[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].State;
            this.PostalCode[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].PostalCode;
            this.Relationship[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].Relationship; //Only for Dependent
            this.PhoneNumber[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].PhoneNumber;
            this.ClientID[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].ClientID;
            this.ClientName[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].ClientName;
            this.PlanID[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].PlanID;
            this.SSN[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].SocialSecurityNumber;
            this.CertificateNumber[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].CertificateNumber;
            this.AlternateID1[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].AlternateID1;
            this.AlternateID2[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].AlternateID2;
            this.MedicareID[iIndex] =
              this.getAdminConfigurationtResp.Response.ConfigurableFields[
                innerIdx
              ].MedicareID;
          }
        }
      }
    }
    this.printAdminConfiguration();
  }

  ParseInsuranceClientSettings = () => {
    if (
      typeof this.getAdminConfigurationtResp.Response.InsurerClientSettings !=
      'undefined'
    ) {
      this.insuranceClientOid =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.oid;
      this.AllowMembersToRegister =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.AllowMembersToRegister;
      this.AllowDependentsToRegister =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.AllowDependentsToRegister;
      this.DefaultMemberRole =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.DefaultMemberRole;
      this.DefaultDependentRole =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.DefaultDependentRole;
      this.DependentRegistrationAgeLimit =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.DependentRegistrationAgeLimit;
      this.TwoFARequired =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.TwoFARequired;
      this.InvalidOTPAttemptRestriction =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.InvalidAttemptRestriction;
      this.OTPLength =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.OTPLength;
      this.OTPExpiresIn =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.OTPExpiresIn;
      this.FirstTimeRegistration =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.FirstTimeRegistration;
      this.Login =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.Login;
      this.FrequencyForTwoFA =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.FrequencyForTwoFA;
      this.AllowSetTrustedDevice =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.AllowSetTrustedDevice;
      this.FrequencyForTrustedDevice =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.FrequencyForTrustedDevice;
      this.FrequencyTypeForTrustedDevice =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.FrequencyTypeForTrustedDevice;
      this.InvalidOTPAttempts =
        this.getAdminConfigurationtResp.Response.InsurerClientSettings.InvalidOTPAttempts;
    }
  };

  ParseResetOptions = () => {
    let iIndex = 0,
      resetOptionsLength = 0;

    this.initializeResetOptions();
    if (
      typeof this.getAdminConfigurationtResp.Response.ResetOptions !=
      'undefined'
    ) {
      resetOptionsLength =
        this.getAdminConfigurationtResp.Response.ResetOptions?.length;
      this.resetOptionsLength = resetOptionsLength;
      for (iIndex = 0; iIndex < resetOptionsLength; iIndex++) {
        this.resetOid[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].OID;
        this.resetRecordType[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].RecordType;
        this.resetMemberType[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].MemberType;
        this.resetDisclaimer[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].Disclaimer;
        this.resetAllowRecoveryUsingAltMail[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].AllowRecoveryUsingAltMail;
        this.resetFirstName[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].FirstName;
        this.resetLastName[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].LastName;
        this.resetDateOfBirth[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].DateOfBirth;
        this.resetEmail[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].Email;
        this.resetAddressLine1[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].AddressLine1;
        this.resetAddressLine2[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].AddressLine2;
        this.resetCity[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].City;
        this.resetState[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].State;
        this.resetPostalCode[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].PostalCode;
        this.resetRelationship[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].Relationship;
        this.resetPhoneNumber[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].PhoneNumber;
        this.resetClientID[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].ClientID;
        this.resetClientName[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].ClientName;
        this.resetPlanID[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].PlanID;
        this.resetSSN[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].SocialSecurityNumber;
        this.resetCertificateNumber[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].CertificateNumber;
        this.resetAlternateID1[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].AlternateID1;
        this.resetAlternateID2[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].AlternateID2;
        this.resetMedicareID[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].MedicareID;
        this.resetAlternateEmail[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[iIndex].Email;
        this.resetMemberID[iIndex] =
          this.getAdminConfigurationtResp.Response.ResetOptions[
            iIndex
          ].CertificateNumber;
      }
    }
  };

  ParsePasswordRules = () => {
    if (
      typeof this.getAdminConfigurationtResp.Response.PasswordRules !=
      'undefined'
    ) {
      this.pwdRulesOid =
        this.getAdminConfigurationtResp.Response.PasswordRules.OID;
      this.pwdRulesPasswordMinLength =
        this.getAdminConfigurationtResp.Response.PasswordRules.PasswordMinLength;
      this.pwdRulesPasswordMaxLength =
        this.getAdminConfigurationtResp.Response.PasswordRules.PasswordMaxLength;
      this.pwdRulesNoOfUpperCaseReqd =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .NoOfUpperCaseReqd === parseInt(true)
          ? 1
          : 0;
      this.pwdRulesNoOfNumericsReqd =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .NoOfNumericsReqd === parseInt(true)
          ? 1
          : 0;
      this.pwdRulesNoOfSpecialCharactersReqd =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .NoOfSpecialCharactersReqd === parseInt(true)
          ? 1
          : 0;
      this.pwdRulesRestrictQWERTYLetters =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .RestrictQWERTYLetters === parseInt(true)
          ? 1
          : 0;
      this.pwdRulesAllowSpacesInPassword =
        this.getAdminConfigurationtResp.Response.PasswordRules.AllowSpacesInPassword;
      this.pwdRulesAllowUnlockDisabledLogin =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .AllowUnlockDisabledLogin === parseInt(true)
          ? 'YES'
          : 'NO';
      this.pwdRulesInvalidAttemptRestriction =
        this.getAdminConfigurationtResp.Response.PasswordRules
          .InvalidAttemptRestriction === parseInt(true)
          ? 'YES'
          : 'NO';
      this.pwdRulesNoOfInvalidPasswordRecoveries =
        this.getAdminConfigurationtResp.Response.PasswordRules.NoOfInvalidPasswordRecoveries;
      this.pwdRulesNoOfInvalidAttempts =
        this.getAdminConfigurationtResp.Response.PasswordRules.NoOfInvalidAttempts;
    }
  };

  initializeAdminConfig() {
    let iIndex = 0;
    for (iIndex = 0; iIndex < this.RegMethods?.length; iIndex++) {
      this.Oid[iIndex] = null;
      this.MemberType[iIndex] = this.RegMethods[iIndex].MemberType;
      this.RegistrationBy[iIndex] = this.RegMethods[iIndex].RegType;
      this.WaysOfReg[iIndex] = false;
      this.NumberOfItemsToMatch[iIndex] = 0;
      this.FirstName[iIndex] = 'Invisible';
      this.LastName[iIndex] = 'Invisible';
      this.DateOfBirth[iIndex] = 'Invisible';
      this.Email[iIndex] = 'Invisible';
      this.AddressLine1[iIndex] = 'Invisible';
      this.AddressLine2[iIndex] = 'Invisible';
      this.Status[iIndex] = 'Invisible';
      this.City[iIndex] = 'Invisible';
      this.State[iIndex] = 'Invisible';
      this.PostalCode[iIndex] = 'Invisible';
      this.Relationship[iIndex] = 'Invisible'; //Only for Dependent
      this.PhoneNumber[iIndex] = 'Invisible';
      this.ClientID[iIndex] = 'Invisible';
      this.ClientName[iIndex] = 'Invisible';
      this.PlanID[iIndex] = 'Invisible';
      this.SSN[iIndex] = 'Invisible';
      this.CertificateNumber[iIndex] = 'Invisible';
      this.AlternateID1[iIndex] = 'Invisible';
      this.AlternateID2[iIndex] = 'Invisible';
      this.MedicareID[iIndex] = 'Invisible';
    }
  }

  initializeResetOptions() {
    let iIndex = 0;
    const resetOptionsLength = 2; //always two - one for email reset and other for password reset
    this.resetOptionsLength = resetOptionsLength;
    for (iIndex = 0; iIndex < resetOptionsLength; iIndex++) {
      this.resetOid[iIndex] = null;
      this.resetRecordType[iIndex] = iIndex === 0 ? 'Email' : 'Password';
      this.resetMemberType[iIndex] = '';
      this.resetDisclaimer[iIndex] = '';
      this.resetAllowRecoveryUsingAltMail[iIndex] = 'NO';
      this.resetFirstName[iIndex] = 'Invisible';
      this.resetLastName[iIndex] = 'Invisible';
      this.resetDateOfBirth[iIndex] = 'Invisible';
      this.resetEmail[iIndex] = 'Invisible';
      this.resetAddressLine1[iIndex] = 'Invisible';
      this.resetAddressLine2[iIndex] = 'Invisible';
      this.resetCity[iIndex] = 'Invisible';
      this.resetState[iIndex] = 'Invisible';
      this.resetPostalCode[iIndex] = 'Invisible';
      this.resetRelationship[iIndex] = 'Invisible';
      this.resetPhoneNumber[iIndex] = 'Invisible';
      this.resetClientID[iIndex] = 'Invisible';
      this.resetClientName[iIndex] = 'Invisible';
      this.resetPlanID[iIndex] = 'Invisible';
      this.resetSSN[iIndex] = 'Invisible';
      this.resetCertificateNumber[iIndex] = 'Invisible';
      this.resetAlternateID1[iIndex] = 'Invisible';
      this.resetAlternateID2[iIndex] = 'Invisible';
      this.resetMedicareID[iIndex] = 'Invisible';
      this.resetAlternateEmail[iIndex] = 'Invisible';
      this.resetMemberID[iIndex] = 'Invisible';

      this.resetFirstNameOption[iIndex] = 'Optional';
      this.resetLastNameOption[iIndex] = 'Optional';
      this.resetDateOfBirthOption[iIndex] = 'Optional';
      this.resetRelationshipOption[iIndex] = 'Optional';
      this.resetPhoneNumberOption[iIndex] = 'Optional';
      this.resetSSNOption[iIndex] = 'Optional';
      this.resetAlternateID1Option[iIndex] = 'Optional';
      this.resetAlternateID2Option[iIndex] = 'Optional';
      this.resetPostalCodeOption[iIndex] = 'Optional';
      this.resetMedicareIDOption[iIndex] = 'Optional';
      this.resetAlternateEmailOption[iIndex] = 'Optional';
      this.resetMemberIDOption[iIndex] = 'Optional';
    }
  }

  printAdminConfiguration() {
    let iIndex;

    for (iIndex = 0; iIndex < this.RegMethods?.length; iIndex++) {
      console.log(this.Oid[iIndex]);
      console.log(this.MemberType[iIndex]);
      console.log(this.RegistrationBy[iIndex]);
      console.log(this.WaysOfReg[iIndex]);
      console.log(this.NumberOfItemsToMatch[iIndex]);
      console.log(this.FirstName[iIndex]);
      console.log(this.LastName[iIndex]);
      console.log(this.DateOfBirth[iIndex]);
      console.log(this.Email[iIndex]);
      console.log(this.AddressLine1[iIndex]);
      console.log(this.AddressLine2[iIndex]);
      console.log(this.Status[iIndex]);
      console.log(this.City[iIndex]);
      console.log(this.State[iIndex]);
      console.log(this.PostalCode[iIndex]);
      console.log(this.Relationship[iIndex]); //Only for Dependent
      console.log(this.PhoneNumber[iIndex]); //missing
      console.log(this.ClientID[iIndex]);
      console.log(this.ClientName[iIndex]);
      console.log(this.PlanID[iIndex]);
      console.log(this.SSN[iIndex]);
      console.log(this.CertificateNumber[iIndex]);
      console.log(this.AlternateID1[iIndex]);
      console.log(this.AlternateID2[iIndex]);
      console.log(this.MedicareID[iIndex]);
    }
  }

  resetAdminConfigurationResp() {
    this.getAdminConfigurationtResp = null;
    this.Oid = [];
    //"MemberID",
    //"ActivationCode",
    //"UserInfo"
    this.RegistrationBy = [];

    //"Employee",
    //"Dependent"
    this.MemberType = [];
    this.WaysOfReg = [];
    //Only UserInfo
    this.NumberOfItemsToMatch = [];
    //"Invisible",
    //"Visible",
    //"Required" - only of userInfo
    this.FirstName = [];
    this.LastName = [];
    this.DateOfBirth = [];
    this.Email = [];
    this.AddressLine1 = [];
    this.AddressLine2 = [];
    this.Status = [];
    this.City = [];
    this.State = [];
    this.PostalCode = [];
    this.Relationship = []; //Only for Dependent
    this.PhoneNumber = [];
    this.ClientID = [];
    this.ClientName = [];
    this.PlanID = [];
    this.SSN = [];
    this.CertificateNumber = [];
    this.AlternateID1 = [];
    this.AlternateID2 = [];
    this.MedicareID = [];

    //Insurance Client Settings
    this.insuranceClientOid = null;
    this.AllowMembersToRegister = 'NO';
    this.AllowDependentsToRegister = 'NO';
    this.DefaultMemberRole = 'NA';
    this.DefaultDependentRole = 'NA';
    this.DependentRegistrationAgeLimit = 0;
    this.TwoFARequired = 'NO';
    this.InvalidOTPAttemptRestriction = 'false';
    this.OTPLength = 0;
    this.OTPExpiresIn = 0;
    this.FirstTimeRegistration = 'TRUE';
    this.Login = 'TRUE';
    this.FrequencyForTwoFA = 0;
    this.AllowSetTrustedDevice = 'NO';
    this.FrequencyForTrustedDevice = 0;
    this.FrequencyTypeForTrustedDevice = 'Days';
    this.InvalidOTPAttempts = 0;

    //Reset Options
    this.resetOptionsLength = 0;
    this.resetOid = [];
    this.resetRecordType = [];
    this.resetMemberType = [];
    this.resetDisclaimer = [];
    this.resetAllowRecoveryUsingAltMail = [];
    this.resetFirstName = [];
    this.resetLastName = [];
    this.resetDateOfBirth = [];
    this.resetEmail = [];
    this.resetAddressLine1 = [];
    this.resetAddressLine2 = [];
    this.resetCity = [];
    this.resetState = [];
    this.resetPostalCode = [];
    this.resetRelationship = [];
    this.resetPhoneNumber = [];
    this.resetClientID = [];
    this.resetClientName = [];
    this.resetPlanID = [];
    this.resetSSN = [];
    this.resetCertificateNumber = [];
    this.resetAlternateID1 = [];
    this.resetAlternateID2 = [];
    this.resetMedicareID = [];
    this.resetAlternateEmail = [];
    this.resetMemberID = [];

    this.resetFirstNameOption = [];
    this.resetLastNameOption = [];
    this.resetDateOfBirthOption = [];
    this.resetRelationshipOption = [];
    this.resetPhoneNumberOption = [];
    this.resetSSNOption = [];
    this.resetAlternateID1Option = [];
    this.resetAlternateID2Option = [];
    this.resetPostalCodeOption = [];
    this.resetMedicareIDOption = [];
    this.resetAlternateEmailOption = [];
    this.resetMemberIDOption = [];

    //Password Rules
    this.pwdRulesOid = null;
    this.pwdRulesPasswordMinLength = 0;
    this.pwdRulesPasswordMaxLength = 0;
    this.pwdRulesNoOfUpperCaseReqd = 0;
    this.pwdRulesNoOfNumericsReqd = 0;
    this.pwdRulesNoOfSpecialCharactersReqd = 0;
    this.pwdRulesRestrictQWERTYLetters = 0;
    this.pwdRulesAllowSpacesInPassword = 'NO';
    this.pwdRulesNoOfLastPasswordsUsed = 0;
    this.pwdRulesAllowUnlockDisabledLogin = 'NO';
    this.pwdRulesInvalidAttemptRestriction = 'NO';
    this.pwdRulesNoOfInvalidPasswordRecoveries = 0;
    this.pwdRulesNoOfInvalidAttempts = 0;
  }
}
export default new GetAdminConfiguration();
